import { render, staticRenderFns } from "./changeChannel.vue?vue&type=template&id=78c6aec5"
import script from "./changeChannel.vue?vue&type=script&lang=js"
export * from "./changeChannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports